import { InfoIcon, TimerIcon } from '@assets/icons';
import { FormCard, FormSelect, FormTextInput, FormToggle } from '@components/form';
import { Group } from '@components/layout';
import { Tooltip } from '@components/tooltip';
import { Typography } from '@components/typography';
import { Collapse, MenuItem } from '@mui/material';
import { useField } from 'formik';

export const AutoStopField = () => {
  const [autoStopEnabledField] = useField<boolean>('autoStopEnabled');
  return (
    <FormCard>
      <Group alignItems="center" justifyContent="space-between">
        <Group gap={1} alignItems="center">
          <TimerIcon size={16} />
          <Typography variant="body2">Auto stop</Typography>
          <Tooltip title="Automatically stop the server when CPU usage falls below the threshold for the specified duration.">
            <InfoIcon size={10} />
          </Tooltip>
        </Group>
        <FormToggle name="autoStopEnabled" maintainGutters={false} />
      </Group>
      <Collapse in={autoStopEnabledField.value}>
        <Group gap={2} alignItems="flex-end" sx={{ mt: 1.5 }}>
          <FormSelect label="Timeout" name="autoStopTimeoutMinutes" small maintainGutters={false}>
            <MenuItem value={60}>1 hour</MenuItem>
            <MenuItem value={120}>2 hours</MenuItem>
            <MenuItem value={180}>3 hours</MenuItem>
            <MenuItem value={360}>6 hours</MenuItem>
            <MenuItem value={720}>12 hours</MenuItem>
            <MenuItem value={1440}>24 hours</MenuItem>
          </FormSelect>
          <FormTextInput
            label="CPU Threshold"
            type="number"
            name="autoStopCpuThreshold"
            placeholder="20"
            small
            min={5}
            max={100}
            endAdornment={
              <Typography variant="caption2" color="input.label.default">
                %
              </Typography>
            }
            maintainGutters={false}
          />
        </Group>
      </Collapse>
    </FormCard>
  );
};
